import React from 'react';

import { flagStyles } from '../settings';

const SvgBD = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-408px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgBD;
